import React from "react"
import { Text } from "@chakra-ui/react"

const CardDescription: React.FC = ({ children }) => {
  return <Text fontSize="md">{children}</Text>
}

export default CardDescription
